var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M22.5 3.375C22.5 2.33906 21.6609 1.5 20.625 1.5H15.375C14.3391 1.5 13.5 2.33906 13.5 3.375V8.625C13.5 9.66094 14.3391 10.5 15.375 10.5H20.625C21.6609 10.5 22.5 9.66094 22.5 8.625V3.375ZM10.5 15.375C10.5 14.3391 9.66094 13.5 8.625 13.5H3.375C2.33906 13.5 1.5 14.3391 1.5 15.375V20.625C1.5 21.6609 2.33906 22.5 3.375 22.5H8.625C9.66094 22.5 10.5 21.6609 10.5 20.625V15.375Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 3.75C10.5 2.50781 9.49219 1.5 8.25 1.5H3.75C2.50781 1.5 1.5 2.50781 1.5 3.75V8.25C1.5 9.49219 2.50781 10.5 3.75 10.5H8.25C9.49219 10.5 10.5 9.49219 10.5 8.25V3.75ZM22.5 15.75C22.5 14.5078 21.4922 13.5 20.25 13.5H15.75C14.5078 13.5 13.5 14.5078 13.5 15.75V20.25C13.5 21.4922 14.5078 22.5 15.75 22.5H20.25C21.4922 22.5 22.5 21.4922 22.5 20.25V15.75Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTemplate);
export default __webpack_public_path__ + "static/media/ic-template.8f57f59be9443d9f24634b035136924c.svg";
export { ForwardRef as ReactComponent };